import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, colours, Icon } from '@mendeley-internal/react-ui';
import styled from 'styled-components';
import PdfIcon from '../PdfIcon';
import { getEntitlement } from '../../actions/entitlements';
import AddToLibrary from './AddToLibrary';
import SignIn from './SignIn';
import BounceLoader from '../BounceLoader';
import {
  showPdf,
  showFullText,
} from '../../actions/document';

if (process.browser) require('./PublicationActions.scss');

const StyledButton = styled(Button)`
  margin-left: 1rem;
  color: ${colours('els-blue')};
  box-shadow: inset 0 0 0 1px ${colours('els-blue')};

  ${Icon}:before {
    color: ${colours('els-blue')};
  }

  &:hover {
    text-decoration: none;
  }
`;

class PublicationActions extends Component {
  componentDidMount() {
    const {
      doc,
      checkedEntitlement,
      psiEnabled,
    } = this.props;

    if (psiEnabled && doc.hasPdf && !checkedEntitlement) {
      this.props.getEntitlement(doc.id);
    }
  }

  render() {
    const {
      doc,
      isAuthenticated,
      isEntitled,
      psiEnabled,
      checkedEntitlement,
    } = this.props;

    const { doi } = doc.identifiers || {};

    if (!psiEnabled) {
      return (
        <div className="publication-actions">
          {!isAuthenticated && (
            <SignIn doc={doc} />
          )}
          {isAuthenticated && (
            <AddToLibrary doc={doc} />
          )}
          {doi && (
            <StyledButton
              secondary
              iconName="externalLink"
              iconBefore
              data-name="open-full-text"
              href={`//dx.doi.org/${doi}`}
              target="_blank"
              onClick={() => this.props.showFullText({ doc })}
            >
              Get full text at journal
            </StyledButton>
          )}
        </div>
      );
    }

    const showSignIn =
      !isAuthenticated &&
      (!doc.hasPdf || (doc.hasPdf && checkedEntitlement));

    const showViewPdf =
      isAuthenticated && isEntitled;

    const showGetFullText =
      doi && (!doc.hasPdf || (doc.hasPdf && checkedEntitlement && !isEntitled));

    return (
      <div className="publication-actions">
        {showSignIn && (
          <SignIn
            doc={doc}
            isEntitled={isEntitled}
          />
        )}
        {isAuthenticated && (
          <AddToLibrary doc={doc} />
        )}
        {showViewPdf && (
          <StyledButton
            secondary
            className="btn-view-pdf"
            size="medium"
            target="_blank"
            href={`/research-papers/api/pdf/${doc.id}/${doi ? `?doi=${doi}` : ''}`}
            data-name="view-pdf"
            onClick={() => this.props.showPdf(doc.id)}
          >
            <PdfIcon /> View PDF
          </StyledButton>
        )}
        {showGetFullText && (
          <StyledButton
            secondary
            iconName="externalLink"
            iconBefore
            data-name="open-full-text"
            href={`//dx.doi.org/${doi}`}
            target="_blank"
            onClick={() => this.props.showFullText({ doc })}
          >
            Get full text at journal
          </StyledButton>
        )}
        {doc.hasPdf && !checkedEntitlement && (
          <BounceLoader />
        )}
      </div>
    );
  }
}

const mapStateToPorps = (state, props) => ({
  psiEnabled: state.config.features.psiEnabled,
  isAuthenticated: state.session.isAuthenticated,
  isEntitled: state.entitlements[props.doc.id],
  checkedEntitlement: typeof state.entitlements[props.doc.id] !== 'undefined',
});

const mapDispatchToProps = {
  getEntitlement,
  showPdf,
  showFullText,
};

export default connect(mapStateToPorps, mapDispatchToProps)(PublicationActions);



// WEBPACK FOOTER //
// ./src/universal/ui/components/PublicationActions/PublicationActions.js